module.exports = __webpack_public_path__ + "static/img/onlinebuy.5ed43d73.svg";